import { Button, Input, InputNumber } from 'antd';
import { BuyerFilterParams } from './service';
import { useTranslate } from '@tolgee/react';
import StatusButton from 'components/StatusButton';
import { useEffect, useRef, useState } from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { useSize } from 'ahooks';

const lineHeight = 44;

function BuyerFilter({
  visible,
  filter,
  onSearch,
  onReset,
}: {
  visible: boolean;
  filter: BuyerFilterParams;
  onSearch: (value: BuyerFilterParams) => Promise<any>;
  onReset: () => Promise<any>;
}) {
  const [value, setValue] = useState(filter);
  useEffect(() => {
    setValue({
      ...filter,
      filterBadCommentRatio:
        typeof filter.filterBadCommentRatio === 'number'
          ? Number((filter.filterBadCommentRatio * 100).toFixed(1))
          : undefined,
      filterReturnTradeRatio:
        typeof filter.filterReturnTradeRatio === 'number'
          ? Number((filter.filterReturnTradeRatio * 100).toFixed(1))
          : undefined,
    });
  }, [filter]);

  const {
    filterBuyerNick,
    filterCumuBadComment,
    filterBadCommentRatio,
    filterCumuReturnTrade,
    filterReturnTradeRatio,
  } = value;

  const { t } = useTranslate();

  const ref = useRef<HTMLDivElement>(null);

  const { height = 0 } = useSize(ref) || {};

  const foldEnable = height > lineHeight;

  const [isfold, setIsfold] = useState(true);

  return (
    <Container style={visible ? undefined : { display: 'none' }}>
      <section style={height ? { height: isfold ? lineHeight : height } : undefined}>
        <div ref={ref}>
          <Input
            placeholder={t('department.请输入x', { x: t('买家昵称') })}
            value={filterBuyerNick}
            onChange={({ target: { value: filterBuyerNick } }) =>
              setValue({ ...value, filterBuyerNick })
            }
          />
          <InputNumber
            addonBefore={`${t('差评数')} ≥`}
            placeholder={t('trade.请输入')}
            precision={0}
            min={0}
            value={filterCumuBadComment}
            onChange={(num) =>
              setValue({
                ...value,
                filterCumuBadComment: typeof num === 'number' ? num : undefined,
              })
            }
          />
          <InputNumber
            addonBefore={`${t('差评率')} ≥`}
            placeholder={t('trade.请输入')}
            addonAfter="%"
            precision={1}
            max={100}
            min={0}
            value={filterBadCommentRatio}
            onChange={(num) =>
              setValue({
                ...value,
                filterBadCommentRatio: typeof num === 'number' ? num : undefined,
              })
            }
          />
          <InputNumber
            addonBefore={`${t('退货/退款数')} ≥`}
            placeholder={t('trade.请输入')}
            precision={0}
            min={0}
            value={filterCumuReturnTrade}
            onChange={(num) =>
              setValue({
                ...value,
                filterCumuReturnTrade: typeof num === 'number' ? num : undefined,
              })
            }
          />
          <InputNumber
            addonBefore={`${t('退货/退款率')} ≥`}
            placeholder={t('trade.请输入')}
            addonAfter="%"
            precision={1}
            max={100}
            min={0}
            value={filterReturnTradeRatio}
            onChange={(num) =>
              setValue({
                ...value,
                filterReturnTradeRatio: typeof num === 'number' ? num : undefined,
              })
            }
          />
        </div>
      </section>
      <div>
        <StatusButton
          type="primary"
          onClick={() =>
            onSearch({
              ...value,
              filterBadCommentRatio:
                typeof value.filterBadCommentRatio === 'number'
                  ? value.filterBadCommentRatio / 100
                  : undefined,
              filterReturnTradeRatio:
                typeof value.filterReturnTradeRatio === 'number'
                  ? value.filterReturnTradeRatio / 100
                  : undefined,
            })
          }
        >
          {t('review.查询')}
        </StatusButton>
        <StatusButton onClick={onReset}>{t('filter.reset')}</StatusButton>
        {foldEnable && (
          <Button type="link" onClick={() => setIsfold(!isfold)}>
            {t('更多筛选')}
            {isfold ? <DownOutlined /> : <UpOutlined />}
          </Button>
        )}
      </div>
    </Container>
  );
}

const Container = styled.div`
  > section {
    overflow: hidden;
    > div {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 0 12px;
      transition: all 0.3s ease-out;
      > * {
        margin-bottom: 12px;
      }
      > input {
        width: 240px;
      }
    }
  }
  > div {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    > * {
      margin-right: 14px;
    }
  }
`;

export default BuyerFilter;
